/**
 * 后端 JSON 响应的公共协议。
 *
 * Rust 旧响应偶尔省略 data，客户端入口会将其归一为 null；新接口应始终返回完整三元组。
 */
export interface ApiResponse<T = unknown> {
  /** 后端业务码。 */
  code: number
  /** 后端业务消息。 */
  msg: string
  /** 后端业务数据；无数据时为 null。 */
  data: T | null
}

/** 迁移期间用于接收旧响应的兼容形态。 */
/** 将旧响应归一为前端内部使用的完整响应体。 */
export const normalizeApiResponse = <T>(
  payload: Partial<ApiResponse<T>>
): ApiResponse<T> => ({
  code: typeof payload.code === 'number' ? payload.code : 500,
  msg: typeof payload.msg === 'string' ? payload.msg : '',
  data: payload.data ?? null
})

export const unwrapApiData = <T>(response: ApiResponse<T>): T => {
  if (response.data == null) {
    throw new Error(response.msg || 'Response data is missing')
  }
  return response.data
}
